
<template>
  <vue-highcharts :highcharts="Highcharts" :options="options" ref="chart"></vue-highcharts>    
</template>

<script>
  import VueHighcharts from "vue2-highcharts";
  import More from "highcharts/highcharts-more";
  import Highcharts from "highcharts";
  import SolidGauge from 'highcharts/modules/solid-gauge';

  More(Highcharts);
  SolidGauge(Highcharts);

  var stringUnit = '';
  
  export default {
    props: ['settings', 'value'],

    components: {VueHighcharts},
  
    data() {
      return {
        options: {},
        Highcharts,
      };
    },

    created() {
      this.options = this.settings;

      if(this.values)
        this.load();
    },

    watch: {
      value() {
        this.load();
      }
    },

    methods: {
      load() {
        if(this.$refs.chart == undefined)
          return;

        let gauge = this.$refs.chart.getChart();
        
        stringUnit = this.value.stringUnit;

        if(gauge.series[0].points[0] != undefined) {
          //Se presente aggiorno il valore
          let point = gauge.series[0].points[0];
          point.update(this.value.value);        
        } else {
          //Aggiungo il valore
          gauge.series[0].addPoint(this.value.value)
        }

        //Aggiorno l'unità di misura
        gauge.update({'series':[{
          dataLabels: {
            formatter: function () { return this.y + ' ' + stringUnit}
          }}
        ]});
      }      
    }
};
</script>